import React from 'react';
import './Loader.scss';

const Loader: React.FC = () => {
    return (
        <div className="loader-overlay">
            {/* Floating Particles */}
            <div className="floating-particles">
                <div className="particle"></div>
                <div className="particle"></div>
                <div className="particle"></div>
                <div className="particle"></div>
                <div className="particle"></div>
            </div>
            
            {/* Main Loader Content */}
            <div className="loader-content">
                {/* Multi-layered Spinner */}
                <div className="spinner"></div>
                
                {/* Animated Text */}
                <div>
                    <h2 className="loader-text">Loading Vivvy</h2>
                    <p className="loader-subtitle">Preparing your dashboard...</p>
                </div>
                
                {/* Animated Dots */}
                <div className="loader-dots">
                    <div className="dot"></div>
                    <div className="dot"></div>
                    <div className="dot"></div>
                </div>
                
                {/* Progress Bar */}
                <div className="loader-progress"></div>
            </div>
        </div>
    );
};

export default Loader;
